import Admin__NamespacesController from './namespaces.js'

Skylark.App.Controllers.register({
  Admin__NamespacesController
})
